__webpack_require__.p = "/wp-content/themes/gs-starter-theme/public/";